<div class="content">
  <div class="container-fluid">
    <div class="page-title flex">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> {{'SMNP TRAP' | translate}}
      </h1>
      <span>Last update : {{trap_LastUpdateTime}}</span>
    </div>
    <div class="page-filter" style="margin: 0 0 0 0">
      <div class="page-title sub-title border-b-radius-none">
        <h5 class="float-left">{{trap_Brand}} - {{trap_Name}}</h5>
        <div>
          <button pButton type="button" label="Add" icon="fa fa-plus" class="{{Confirm_button}} update" (click)="showDialog()"></button>
          <button pButton type="button" label="Edit" icon="fa fa-pencil-square-o" [disabled]="selectedTrap == null" class="{{Confirm_button}} update" (click)="showEditDialog()"></button>
          <button pButton type="button" label="Delete" icon="fa fa-trash" class="{{Confirm_button}}" [disabled]="selectedTrap == null" (click)="showConfirmDialog()"></button>
        </div>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table class="deviceTable pageAllOptions" [columns]="trapMgtList_cols" [value]="trapMgtList" [rows]="10" [paginator]="true" [scrollable]="true"
        selectionMode="single" [(selection)]="selectedTrap">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr [pSelectableRow]="rowData">
            <td style="width: 150px" class="col-nowrap">{{rowData.categoryStr}}</td>
            <td style="width: 250px" class="col-nowrap">{{rowData.trapName}}</td>
            <td style="width: 250px" class="col-nowrap">{{rowData.trapOID}}</td>
            <td style="width: 400px" class="col-nowrap">{{rowData.desc}}</td>
            <td style="width: 150px" class="col-nowrap">{{rowData.levelStr}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="trapMgtList_cols.length">
              <div class="ui-emptymessage">No Data found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-dialog header="{{dialogInput.UpdateType | translate}}" [(visible)]="displayDialog" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000" class="scrollDialog">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Category</label>
      <div class="select">
        <p-select [options]="categoryOptions" [(ngModel)]="dialogInput.category" [style]="{'width':'100%'}" [disabled]="dialogInput.UpdateType === 'Edit SNMP Trap'"></p-select>
      </div>
    </div>
    <div class="form-group">
      <label translate>Trap Name</label>
      <input type="text" size="50" maxlength="50" class="form-control pInputText" [(ngModel)]="dialogInput.trapName" pInputText>
    </div>
    <div class="form-group">
      <label translate>Trap OID</label>
      <input type="text" class="form-control pInputText" [(ngModel)]="dialogInput.trapOID" pInputText pattern="^(\.\d+)+$" #checkOid="ngModel">
      <p-message severity="error" text="Trap Oid is invalid." *ngIf="checkOid.invalid && (checkOid.dirty || checkOid.touched)"></p-message>
    </div>

    <div class="form-group">
      <label translate>Description</label>
      <textarea [rows]="5" size="150" maxlength="150" pInputTextarea [(ngModel)]="dialogInput.desc"></textarea>
    </div>
    <div class="form-group">
      <label translate>Alert Level</label>
      <div class="select">
        <p-select [options]="levelOptions" [(ngModel)]="dialogInput.level" [style]="{'width':'100%'}" appendTo="body"></p-select>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="saveTrapData();" label="{{'Save' | translate}}" class="ui-button-danger" [disabled]="checkOid.invalid || !dialogInput.trapName || !dialogInput.trapOID"></button>
    <button type="button" pButton (click)="displayDialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="{{'Confirm' | translate}}" [(visible)]="displayConfirmDialog" [modal]="true" [style]="{'width': '450px'}" [baseZIndex]="10000" class="ConfirmDialog">
  <div cla="page-content-body">
    <p translate>Do you really want to delete this record?</p>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="{{'Confirm' | translate}}" class="ui-button-danger" (click)="deleteTrapData()"></button>
      <button type="button" pButton (click)="displayConfirmDialog=false" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>


<p-toast [style]="{marginTop: '70px'}"></p-toast>
